import React, { useState } from "react";
import { Link, ResponsiveImage } from "@quintype/components";
import "./rational-journalism.m.css";
import { Button } from "../../../ui/components";

const latest = [
  {
    img: "https://media.assettype.com/newslaundry%2F2021-05%2Fa1c157c6-a009-40da-8aa1-6c8b62a0ad6f%2FIsha_ashram_illegal_elephant_corridor.jpg?auto=format%2Ccompress&fit=max&dpr=1.0&format=webp&w=1200",
    title: "Investigating Sadhguru’s Isha Foundation",
    link: "https://www.newslaundry.com/nl-sena/on-a-godmans-trail",
    description:
      "The status of his finances, the building of his empire, and his powerful connections",
  },
  {
    img: "https://media.assettype.com/newslaundry%2F2023-11%2F29b268ac-10aa-4ecb-bc64-b54eb368ec4f%2Framdev_AI.jpg?auto=format%2Ccompress&fit=max&dpr=1.0&format=webp&w=1200",
    title: "The Yogi who has it all ",
    link: "https://www.newslaundry.com/nl-sena/the-yogi-who-has-it-all",
    description:
      "The unlikely rise of Baba Ramdev from a Haryana village to business tycoon",
  },
  {
    img: "https://media.assettype.com/newslaundry%2Fimport%2F2017%2F08%2F01-5.jpg?auto=format%2Ccompress&fit=max&dpr=1.0&format=webp&w=1200",
    title: "The rise and fall of Ram Rahim",
    link: "https://www.newslaundry.com/topic/gurmeet-ram-rahim",
    description: "The case, the convictions, and a cult that wreaked havoc",
  },
  //   {
  //   img: "https://media.assettype.com/tnm%2Fimport%2Fsites%2Fdefault%2Ffiles%2Fjaggi.jpg?w=1200&auto=format%2Ccompress&fit=max",
  //   title: "TNM Sadhguru",
  //   link:'https://www.thenewsminute.com/search?q=sadhguru',
  // },
  {
    img: "https://media.assettype.com/newslaundry%2Fimport%2F2016%2F04%2Fyamuna_article_edited.jpg?auto=format%2Ccompress&fit=max&dpr=1.0&format=webp&w=1200",
    title: "Art of Living vs the NGT ",
    link: "https://www.newslaundry.com/topic/art-of-living",
    description: "How the tribunal surrendered the Yamuna",
  },
  {
    img: "https://media.assettype.com/thenewsminute%2Fimport%2Fsites%2Fdefault%2Ffiles%2Fnithyananda_latest_picture_1.jpg?w=1200&auto=format%2Ccompress&fit=max",
    title: "The Nithyananda files",
    link: "https://www.thenewsminute.com/search?q=Nithyananda",
    description:
      "Rape, image rehabilitation, and the establishment of his own ‘country’",
  },
  {
    img: "https://images.assettype.com/newslaundry/2025-07-24/98vm3sl1/dharmasthala.jpg",
    title: "What happened in Dharmasthala?",
    link: "https://www.thenewsminute.com/search?q=dharmasthala",
    description: "A whistleblower, ‘mass burials’, and a media gag order",
  },
];

const StoryItem = ({ story }) => {
  return (
    <div href={`${story.img}`} styleName="read-stories-grid-column">
      <a href={`${story.link}`} target="_blank" style={{ textDecoration: "none" }}>
        <div styleName="section-wrapper-heading-wrapper" style={{ height:'5.2rem' }}>
          <div styleName="section-wrapper-heading">{story.title}</div>
          {/* <div styleName="border-bottom"></div> */}
        </div>
        <div className="qt-image-16x9" styleName="read-stories-grid-image">
          <img
            src={story.img}
            alt={story.title}
            style={{
              width: "100%",
              aspectRatio: "16 / 9",
              objectFit: "cover",
              borderRadius: "8px",
            }}
            layout="responsive"

          />
        </div>
      </a>

      {/* {!!story?.series1?.link && <Link href={`${story.series1.link}`}>
        <h4
          styleName="read-stories-grid-title"
          style={{
            textDecoration: "underline",
            marginTop: "1.5rem",
            textAlign: "center",
          }}
        >
          {story.series1.title}
        </h4>
      </Link>} */}

        <div
          styleName="read-stories-grid-title"
          style={{
            marginTop: "1rem",
            textAlign: "left",
          }}
        >
          {story.description}
        </div>
    </div>
  );
};

function RationalJournalismPage() {
  const [readMore, setReadMore] = useState(false);

  return (
    <div>
      <main styleName="hero-section">
        <div styleName="hero-section-div">
          <div styleName="hero-section-img">
            <img
              src={
                "https://images.assettype.com/newslaundry/2025-07-28/10rrcmeg/revised-.jpg"
              }
              alt={"Rational Journalism"}
              layout="responsive"
              width={1000}
              height={800}
            />
            <div
              style={
                !readMore
                  ? { display: "flex", justifyContent: "space-evenly", flex: 1 }
                  : {}
              }
            >
              <a
                styleName="redirect-link"
                // href="https://rzp.io/rzp/CAy583Glogged"
                href="https://rzp.io/rzp/tXoIEZLsupport"
                target="_blank"
                // externalLink="https://rzp.io/rzp/CAy583Glogged"
                style={{
                  marginTop: "1rem",
                  // width: "40%" ,
                }}
              >
                Contribute Now
              </a>

              {/* <Link
                styleName="redirect-link"
                href="/subscription?ref=nav"
                style={{
                  marginTop: "1rem",
                  ...(!readMore && { width: "40%" }),
                }}
              >
                Subscribe
              </Link> */}
            </div>
          </div>
          <div styleName="hero-section-content">
            <h1 styleName="title">Support rational journalism</h1>
            <p styleName="hero-description-small">
              For millions of people, faith offers succour, hope and guidance.
              But when left unexamined, structures built around faith offer an opportunity for misuse, from questionable practices to political alliances that escape scrutiny.
              <br />
              <br />
              And yet most of the media turns the other way, often funded by conglomerates run by spiritual and religious leaders.
              <br />
              <br />
              Not us.
              <br />
            </p>
            {readMore && (
              <p styleName="hero-description-small">
                We’ve investigated the building of these empires and all the
                laws broken along the way. We’ve asked questions and scrutinised
                the answers, in the spirit of our fundamental duty to cultivate
                scientific temperament.
                <br />
                <br />
                Because we don’t take ads from brands or babas. We’re funded by
                our subscribers, and you can be one too.
                <br />
                <br />
                Support rational journalism that doesn’t defer to money or
                power. Support Newslaundry.
              </p>
            )}
            <div
              style={{ marginTop: "0.5rem" }}
              // styleName="standalone-link-wrapper"
            >
              {/* <Link
                href="https://www.newslaundry.com/2024/12/23/air-pollution-is-an-existential-crisis-thats-why-we-are-making-an-exception"
                styleName="redirect-link"
              > */}
              <Button onClick={() => setReadMore(!readMore)}>
                {readMore ? "Read less" : "Read more"}
              </Button>

              {/* </Link> */}
            </div>
          </div>
        </div>
      </main>
      <section styleName="section-wrapper">
        <div styleName="read-stories-grid">
          {latest.map((story) => (
            <StoryItem key={story.title} story={story} />
          ))}
        </div>
        {/* <div styleName="standalone-link-wrapper">
          <Link href="nl-campaign/fight-to-breathe" styleName="redirect-link">
            Check out all stories
          </Link>
        </div> */}
      </section>
    </div>
  );
}

export { RationalJournalismPage };
